// extracted by mini-css-extract-plugin
export default {"content":"the-view-consent_content__C1LvQ","button":"the-view-consent_button__quZ0V"};